/**
 * ScoreKpiCard.jsx — 요약 KPI 카드 행 맨 오른쪽의 월간 점수 카드
 *
 * 클릭하면 항목별 내역 모달이 열린다(계약율 분모인 잡은 미팅 수를 여기서 확인).
 * 점수 데이터가 없거나(회사에 기준표 없음) 근무구분 판정이 안 되면 렌더하지 않는다.
 */
import React, { useState } from 'react';
import ScoreDetailModal from './ScoreDetailModal';

const fmtScore = (n) => (Number.isFinite(Number(n)) ? String(Math.round(Number(n) * 10) / 10) : '-');

export default function ScoreKpiCard({ data, year, month, isMobile }) {
  const [open, setOpen] = useState(false);
  if (!data || data.enabled === false) return null;
  // 근무유형 이력이 없어 풀/파트 판정이 불가하면 잘못된 점수를 보여주지 않는다
  if (!data.employmentType) return null;

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        onClick={() => setOpen(true)}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen(true); } }}
        style={{
          cursor: 'pointer',
          minHeight: isMobile ? 40 : undefined,
          // PC(flex)에서는 오른쪽 끝으로 밀어 정렬. 모바일(grid)은 셀 배치라 그대로 둔다.
          marginLeft: isMobile ? undefined : 'auto',
        }}
        title="클릭하면 항목별 점수 내역을 볼 수 있습니다."
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 2 }}>
          <span style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 500 }}>점수</span>
          <span style={{ fontSize: 10, fontWeight: 700, padding: '1px 6px', borderRadius: 999, background: 'rgba(124,58,237,0.12)', color: '#7c3aed', whiteSpace: 'nowrap' }}>
            {data.employmentLabel}
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 3 }}>
          <span style={{ fontSize: isMobile ? 18 : 20, fontWeight: 800, color: '#7c3aed', lineHeight: 1 }}>
            {fmtScore(data.totalScore)}
          </span>
          <span style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-muted)' }}>점</span>
        </div>
        <div style={{ fontSize: 10, color: 'var(--text-muted)', marginTop: 3 }}>자세히 ›</div>
      </div>

      <ScoreDetailModal
        open={open}
        onClose={() => setOpen(false)}
        data={data}
        year={year}
        month={month}
        isMobile={isMobile}
      />
    </>
  );
}
